<template>
  <v-app>
    <v-progress-linear
      indeterminate
      fixed
      top
      :active="$store.state.loading.active"
      style="z-index: 10"
    />
    <AuthSessionExpirationStatus />
    <ActionCableStatus />
    <Notification />
    <v-main :style="{ backgroundColor: 'var(--v-background-base)' }">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import ActionCableStatus from "@/components/action_cable_status/index.vue";
import AuthSessionExpirationStatus from "@/components/auth/session_expiration_status/index.vue";
import Notification from "@/components/notification.vue";
import AUTHENTICATION_CHECK from "@/graphql/authentication_check.gql";

export default {
  components: {
    ActionCableStatus,
    AuthSessionExpirationStatus,
    Notification,
  },
  data() {
    return {
      authenticationCheck: false,
    };
  },
  apollo: {
    authenticationCheck: {
      query: AUTHENTICATION_CHECK,
      fetchPolicy: "no-cache",
      pollInterval: 100000,
      update(data) {
        let authenticationCheck = data.authenticationCheck;
        if (authenticationCheck === false) {
          this.$store.dispatch("authentication/unauthenticated");
        }
        return authenticationCheck;
      },
      skip() {
        return this.$store.state.authentication.token === null;
      },
    },
    authorizationChecks: {
      query: require("@/graphql/authorization_checks.gql"),
      pollInterval: 100000,
      update(data) {
        // important
        const user = { ...this.$store.state.authentication.user };
        if (user) {
          user.permissions = data.authorizationChecks;
          this.$store.commit("authentication/setUser", user);
          this.$store.dispatch("authorization/loadAuthorizationsFromUser");
        }
        return data.authorizationChecks;
      },
      skip() {
        return this.$store.state.authentication.token === null;
      },
    },
  },
};
</script>

<style lang="scss">
@import "./assets/main";

body {
  color: var(--v-gray-base);
}
</style>

